import { defineStore } from 'pinia'
import useWheelAnalysisQuery from "@/composables/useWheelAnalysisQuery";
import axios from "axios";
import {useAnalysisStore} from "@/stores/Setup/analysis";

export const useGoalBStore = defineStore('goalB', {
    state: () => {
        return {
            selectedTargets: [false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false]
        }
    },
    getters: {
    },
    actions: {
        async fetchWheelAnalysis() {
            await useWheelAnalysisQuery()
            //console.log(data)
        },
        selectedTargetsChanged() {
            const analysisStore = useAnalysisStore()
            if (analysisStore.wheelAnalysisId  !== null && this.selectedTargets !== null) {  // TODO: add header with token
                const data = { "goal_b_selected_targets": [this.selectedTargets].toString()}
                axios.put(process.env.VUE_APP_API_ROOT + 'api/v1/wheel_analyses/'+ analysisStore.wheelAnalysisId +  '/goal_b_selected_targets', data).then(response => {
                    console.log(response)
                })
            }
        },
    },
    persist: true
})